import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { subscribeToast } from '../../lib/toast';

const STYLES = {
  success: { bg: '#16233b', border: '#2dd4bf' },
  error: { bg: '#3b1620', border: '#f87171' },
  info: { bg: '#16233b', border: '#60a5fa' },
};

export const Toaster = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    return subscribeToast((item) => {
      setItems((prev) => [...prev, item]);
      setTimeout(() => {
        setItems((prev) => prev.filter((i) => i.id !== item.id));
      }, 3200);
    });
  }, []);

  if (items.length === 0) return null;

  return ReactDOM.createPortal(
    <div
      data-testid="toaster-container"
      className="fixed top-4 left-1/2 z-[100000] flex -translate-x-1/2 flex-col gap-2"
    >
      {items.map((item) => {
        const style = STYLES[item.type] || STYLES.info;
        return (
          <div
            key={item.id}
            data-testid={`toast-${item.type}`}
            className="rounded-lg px-4 py-2 text-sm text-white shadow-lg"
            style={{ backgroundColor: style.bg, border: `1px solid ${style.border}` }}
          >
            {item.message}
          </div>
        );
      })}
    </div>,
    document.body
  );
};
